import { render, staticRenderFns } from "./TeamRoles.vue?vue&type=template&id=190ab398"
import script from "./TeamRoles.vue?vue&type=script&lang=js"
export * from "./TeamRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports